import { CriterionType } from '../../../types/screener.type';
import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';

const comanyScoreAC: CriterionType[] = [
  {
    id: 'CSC-10',
    label: 'Overall score',
    shortLabel: 'OverallScore',
    group: AC_GROUPS.companyScore,
    type: AC_TYPES.score,
    withScoreRange: true,
  },
  {
    id: 'CSC-30',
    label: 'Company score (1M)',
    shortLabel: 'Score1M',
    group: AC_GROUPS.companyScore,
    type: AC_TYPES.score,
    withScoreRange: true,
  },
  {
    id: 'CSC-40',
    label: 'Company score (3M)',
    shortLabel: 'Score3M',
    group: AC_GROUPS.companyScore,
    type: AC_TYPES.score,
    withScoreRange: true,
  },
  {
    id: 'CSC-50',
    label: 'Company score (6M)',
    shortLabel: 'Score6M',
    group: AC_GROUPS.companyScore,
    type: AC_TYPES.score,
    withScoreRange: true,
  },
  {
    id: 'CSC-60',
    label: 'Company score (1Y)',
    shortLabel: 'Score1Y',
    group: AC_GROUPS.companyScore,
    type: AC_TYPES.score,
    withScoreRange: true,
  },
  {
    id: 'CSC-70',
    label: 'Earnings score',
    shortLabel: 'EarnScore',
    group: AC_GROUPS.companyScore,
    type: AC_TYPES.score,
    withScoreRange: true,
  },
  {
    id: 'CSC-80',
    label: 'Fundamentals score',
    shortLabel: 'FundScore',
    group: AC_GROUPS.companyScore,
    type: AC_TYPES.score,
    withScoreRange: true,
  },
  {
    id: 'CSC-90',
    label: 'Relative valuation score',
    shortLabel: 'RelValScore',
    group: AC_GROUPS.companyScore,
    type: AC_TYPES.score,
    withScoreRange: true,
  },
  {
    id: 'CSC-100',
    label: 'Price momentum score',
    shortLabel: 'MomScore',
    group: AC_GROUPS.companyScore,
    type: AC_TYPES.score,
    withScoreRange: true,
  },
  {
    id: 'CSC-110',
    label: 'Risk score',
    shortLabel: 'RiskScore',
    group: AC_GROUPS.companyScore,
    type: AC_TYPES.score,
    withScoreRange: true,
  },
];

export default comanyScoreAC;